import React from "react";
import InMemoryTable from "../../components/InMemoryTable/InMemoryTable";

const ChartPage = () => {
  return (
    <div>
      <InMemoryTable />
    </div>
  );
};

export default ChartPage;
